import { useLocation, useMatches } from 'react-router-dom';
import { isValidId } from 'utils/object';

const USER_AGENDA_PATH_PATTERN = /^\/user\/modules\/[^/]+(?:\/m\/[^/]+)?\/(?:Flow|Helios)\/[^/]+(?:\/|$)/;

export const useUserChatbotModuleId = (): string | undefined => {
  const { pathname } = useLocation();
  const matches = useMatches();

  if (!USER_AGENDA_PATH_PATTERN.test(pathname)) return undefined;

  const deepestMatch = matches[matches.length - 1];
  const activeModuleId = deepestMatch?.params.childId ?? deepestMatch?.params.id;

  return isValidId(activeModuleId) ? activeModuleId : undefined;
};
